import React from 'react';
import {Link, useLocation} from 'react-router-dom';
import {clearSession, getCookie} from '../api';

function NavTab({ to, label }) {
  const active = useLocation().pathname.startsWith(to);
  return (
    <Link to={to} className={`py-3 text-sm font-medium border-b-2 ${active ? 'border-emerald-600 text-emerald-600' : 'border-transparent text-gray-500 hover:text-gray-700'}`}>{label}</Link>
  );
}

export default function Layout({ children }) {
  const displayName = getCookie('displayName') ? decodeURIComponent(getCookie('displayName')) : '';

  const handleLogout = () => {
    clearSession();
    window.location.href = '/login';
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-white shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex justify-between items-center h-16">
          <Link to="/" className="flex items-center gap-2">
            <img src="/images/mydocumentsign-logo.png" alt="MyDocumentSign" className="h-16" />
          </Link>
          <div className="flex items-center gap-4">
            {displayName && <span className="text-sm text-gray-600">{displayName}</span>}
            <button onClick={handleLogout} className="text-sm text-gray-600 hover:text-red-600 font-medium">Sign Out</button>
          </div>
        </div>
      </header>
      <nav className="bg-white border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex gap-6">
          <NavTab to="/dashboard" label="Documents" />
          <NavTab to="/templates" label="Templates" />
        </div>
      </nav>
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {children}
      </main>
    </div>
  );
}
